/* assets/label-products-warning.js */
(function () {
  // --- scope to cart page only ---
  if (!/\/cart(?:\/|$)/i.test(location.pathname)) return;

  // Texts
  var INLINE_TXT = 'Please enter a name to label the clothing.';
  var MODAL_TXT  = 'The "Label Products" option was selected, but no name was entered. Please enter a name for the label.';

  // Helpers
  function yesChecked() {
    var yes = document.getElementById('label-yes');
    return !!(yes && yes.checked);
  }
  function nameEmpty() {
    var el = document.getElementById('label-name-cart');
    return !(el && String(el.value || '').trim());
  }
  function isInvalid() {
    return yesChecked() && nameEmpty();
  }

  // Inline error (use existing setInlineError if present; else provide one)
  function ensureInlineRenderer() {
    if (typeof window.setInlineError === 'function') return;

    window.setInlineError = function (show) {
      var nameInput = document.getElementById('label-name-cart');
      if (!nameInput) return;

      var err = document.getElementById('label-name-error');
      if (!err) {
        err = document.createElement('div');
        err.id = 'label-name-error';
        err.setAttribute('role', 'alert');
        err.setAttribute('aria-live', 'polite');
        // keep your visual style; short message here
        err.style.cssText = 'color:#b42318;font-size:1em;font-weight:bold;margin-top:0;margin-bottom:4px;display:none;';
        err.textContent = INLINE_TXT;
        nameInput.insertAdjacentElement('afterend', err);
      }

      nameInput.setAttribute('aria-invalid', show ? 'true' : 'false');
      if (show) {
        nameInput.setAttribute('aria-describedby', 'label-name-error');
        err.style.display = 'block';
      } else {
        nameInput.removeAttribute('aria-describedby');
        err.style.display = 'none';
      }
    };
  }

  function refreshInline() {
    ensureInlineRenderer();
    // show iff Yes selected AND name is empty
    window.setInlineError(isInvalid());
  }

  // Simple blocking modal for checkout attempts (longer message)
  function createModal() {
    var modal = document.createElement('div');
    modal.id = 'label-blocker-modal';
    modal.style.cssText =
      'position:fixed;inset:0;background:rgba(0,0,0,.5);display:flex;align-items:center;justify-content:center;z-index:9999;padding:10px;box-sizing:border-box;';
    modal.innerHTML =
      '<div style="background:#fff;padding:20px;max-width:320px;border-radius:8px;text-align:center;font-family:inherit;">' +
      '<p style="margin-bottom:20px;font-size:1.05em;font-weight:bold;color:#333;">' + MODAL_TXT + '</p>' +
      '<button id="label-blocker-close" style="background:#333;color:#fff;border:none;padding:8px 14px;cursor:pointer;border-radius:4px;">OK</button>' +
      '</div>';
    document.body.appendChild(modal);
    modal.querySelector('#label-blocker-close').addEventListener('click', function () {
      modal.remove();
      var ln = document.getElementById('label-name-cart');
      if (ln) ln.focus();
    });
  }
  function showModalOnce() {
    if (!document.getElementById('label-blocker-modal')) createModal();
  }

  // Determine if a click should be gated (checkout / accelerated / Net30)
  function shouldGate(el) {
    if (!el) return false;
    var href         = (el.getAttribute && el.getAttribute('href')) || '';
    var name         = (el.getAttribute && el.getAttribute('name')) || '';
    var html         = el.outerHTML || '';
    var dataRedirect = (el.getAttribute && el.getAttribute('data-redirect')) || '';

    var isNormal =
      name === 'checkout' ||
      /(?:^|\/)checkout(?:\?|$)/i.test(href) ||
      el.classList.contains('cart__checkout') ||
      el.classList.contains('cart-checkout-button');

    var isAccel =
      el.closest('.additional-checkout-buttons, .shopify-payment-button') ||
      /shop-pay|shoppay|paypal|pay\s*now|google|gpay|apple\s*pay|amazon/i.test(html);

    var isNet30 =
      /\/pages\/net-orders(?:-thank-you)?(?:\?|$)/i.test(href) ||
      /\/pages\/net-orders(?:-thank-you)?(?:\?|$)/i.test(dataRedirect) ||
      (el.matches('input[type="button"]') && /net\s*30/i.test((el.value || el.textContent || '')));

    return isNormal || isAccel || isNet30;
  }

  // Block checkout when invalid; keep inline warning short, modal for block
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest('button, a, input[type="submit"], input[type="button"]');
    if (!el || !shouldGate(el)) return;

    if (isInvalid()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (el.disabled) el.disabled = false;
      refreshInline();
      showModalOnce();
      return false;
    }
  }, true);

  document.addEventListener('submit', function (e) {
    if (!/\/cart(?:\/|$)/.test(location.pathname)) return;
    if (isInvalid()) {
      e.preventDefault();
      refreshInline();
      showModalOnce();
      return false;
    }
  }, true);

  // Keep inline warning live while typing / toggling radios
  document.addEventListener('input', function (e) {
    if (e.target && e.target.id === 'label-name-cart') refreshInline();
  });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'note[Label Products]') refreshInline();
  }, true);

  // === The key addition: re-apply after quantity changes / re-renders ===
  // Your theme dispatches line-item:change:end after cart AJAX updates.
  document.addEventListener('line-item:change:end', function () {
    // Wait a tick for DOM replacement, then restore the inline warning
    setTimeout(refreshInline, 0);
  });

  // Also cover any theme/app section refresh events you already use
  ['cart:updated', 'thb:cart:update', 'cart:refresh', 'shopify:section:load', 'shopify:section:select']
    .forEach(function (evt) {
      document.addEventListener(evt, function () { setTimeout(refreshInline, 0); });
    });

  // Safety net: if the cart form node gets replaced without events, watch it
  var mo;
  function armObserver() {
    var root = document.getElementById('Cart') || document.querySelector('form[action="/cart"]') || document.body;
    try {
      if (mo) mo.disconnect();
      mo = new MutationObserver(function () {
        // If our input is present, keep the inline warning in sync
        if (document.getElementById('label-name-cart')) refreshInline();
      });
      mo.observe(root, { childList: true, subtree: true });
    } catch (_) {}
  }
  armObserver();

  // Initial render
  refreshInline();
})();